import i18n from '../i18n';
import { getOwnerChecklist, getOwnerTour } from './ownerOnboarding';
import {
  getCoachChecklist,
  getCoachTour,
  getCoachWelcome,
  getCoachChecklistUi
} from './coachOnboarding';
import {
  getStudentChecklist,
  getStudentTour,
  getStudentWelcome,
  getStudentChecklistUi
} from './studentOnboarding';
import {
  getParentTour,
  getParentWelcome,
  getParentChecklistUi
} from './parentOnboarding';

const t = (key, opts) => i18n.t(`onboarding:${key}`, opts);

export const ONBOARDING_ROLES = ['Owner', 'Coach', 'Member', 'Parent'];

export function isOnboardingRole(role) {
  return ONBOARDING_ROLES.includes(role);
}

export function getTourForRole(role, ctx) {
  if (role === 'Owner') return getOwnerTour(ctx);
  if (role === 'Coach') return getCoachTour(ctx);
  if (role === 'Member') return getStudentTour(ctx);
  if (role === 'Parent') return getParentTour(ctx);
  return [];
}

export function getChecklistForRole(role, ctx) {
  if (role === 'Owner') return getOwnerChecklist(ctx);
  if (role === 'Coach') return getCoachChecklist(ctx);
  if (role === 'Member') return getStudentChecklist(ctx);
  if (role === 'Parent') return [];
  return [];
}

export function getWelcomeForRole(role) {
  if (role === 'Owner') {
    return {
      subtitle: t('welcomeOwnerSubtitleFull'),
      startLabel: t('welcomeStartSetup')
    };
  }
  if (role === 'Coach') return getCoachWelcome();
  if (role === 'Member') return getStudentWelcome();
  if (role === 'Parent') return getParentWelcome();
  return { subtitle: '', startLabel: t('welcomeStartGeneric') };
}

export function getChecklistUiForRole(role) {
  if (role === 'Owner') {
    return {
      title: t('checklistOwnerTitle'),
      doneTitle: t('checklistOwnerDone'),
      doneMessage: t('checklistOwnerDoneMessage'),
      doneButton: t('checklistOwnerDoneButton'),
      doneRoute: '/schedule'
    };
  }
  if (role === 'Coach') return getCoachChecklistUi();
  if (role === 'Member') return getStudentChecklistUi();
  if (role === 'Parent') return getParentChecklistUi();
  return {
    title: t('checklistDefaultTitle'),
    doneTitle: t('checklistDefaultDoneTitle'),
    doneMessage: '',
    doneButton: t('checklistDefaultDoneButton'),
    doneRoute: '/'
  };
}
